export default __webpack_public_path__ + "locales/az/PeopleTranslations.json?hash=31906c437bce76aad25596165a3abb48";